import Popover from './components/Popover';

export default Popover



// WEBPACK FOOTER //
// ./src/view/component/lib/react-popover/index.js